import { Component, Input } from '@angular/core';
import { Stock } from 'src/app/domain/models/PalletStock';

@Component({
  selector: 'app-stock-stats',
  templateUrl: './stock-stats.component.html',
  styleUrls: ['./stock-stats.component.css']
})
export class StockStatsComponent {

  @Input()
  stock!: Stock
}
